import FJLocalStore from '../../../../store/FJLocalStore';
import styles from './FJTextToImageRightPresetItem.module.less';
import PropTypes from 'prop-types';
import { useRef, useState } from 'react';
import classNames from 'classnames';

const FJTextToImageRightPresetItem = ({ presetInfo, onClickUsePrompt, showIcon = false }) => {
    const videoRef = useRef(null);
    const [isPlayingVideo, setIsPlayingVideo] = useState(false);

    const _onMouseOver = () => {
        setIsPlayingVideo(true);
    };
    const _onMouseLeave = () => {
        setIsPlayingVideo(false);
    };

    return (
        <div className={styles.preset_item_box} onMouseEnter={_onMouseOver} onMouseLeave={_onMouseLeave}>
            <img
                src={presetInfo.imageUrl}
                className={classNames(styles.big_img, !presetInfo.videoUrl ? styles.noVideo : '')}
                alt={presetInfo.prompt}
            />

            {presetInfo.videoUrl && isPlayingVideo && (
                <video src={presetInfo.videoUrl} ref={videoRef} loop autoPlay muted={true} />
            )}

            <div className={styles.item_prompt_box}>
                <div className={styles.prompt}>
                    {presetInfo.smallImageUrl && <img className={styles.img} src={presetInfo.smallImageUrl} alt='' />}
                    <div className={styles.item_prompt_span}>{presetInfo.prompt}</div>
                </div>

                <div className={styles.item_prompt_btn_box}>
                    {showIcon && (
                        <div className={styles.item_prompt_tag_item}>
                            <div className={styles.item_prompt_tag_item_icon_box}>
                                <img
                                    className={styles.item_prompt_tag_item_icon}
                                    src={presetInfo.icon}
                                    alt={presetInfo.name}
                                />
                            </div>
                            <span>{presetInfo.name}</span>
                        </div>
                    )}
                    <div
                        className={styles.use_prompt_btn}
                        onClick={() => onClickUsePrompt && onClickUsePrompt(presetInfo)}
                    >
                        {FJLocalStore._('use-prompt')}
                    </div>
                </div>
            </div>
        </div>
    );
};

FJTextToImageRightPresetItem.propTypes = {
    presetInfo: PropTypes.object,
    onClickUsePrompt: PropTypes.func,
    showIcon: PropTypes.bool,
};

export default FJTextToImageRightPresetItem;
